<template>
    <div class="wrap">
<!--
    <footer class="z-footer-wrap">
      <div class="z-footer clear">
        <div class="z-footer-us clear">
          <div class="z-footer-logo"></div>
          <dl class="clear">
            <dt>400-852-9882</dt>
            <dd>业务合作：010-62353166</dd>
            <dd>电子邮箱：hz@infobigdata.com</dd>
          </dl>
          <div class="z-footer-coder">
            <div class="z-footer-wz">
              <div><img src="../assets/img/weixin_coder.png"></div>
              <em>关注吾征AI公众号</em>
            </div>
            <div class="z-footer-wz">
              <div><img src="../assets/img/app_coder.png"></div>
              <em>下载吾征AI APP</em>
            </div>
          </div>
        </div>
        <div class="z-footer-link">
          Copyright © 2017-2021 中润普达 - <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_blank">京ICP备2021002262号-1</a>
        </div>
      </div>
    </footer> -->
      

  <div class="footer_D">
      <div class="dibu">
          <div class="dibuD">
            <div class="dibiF">
              <div class="dibuD1">
                <img class="img1" src="../assets/images/logo-loading.png" alt="">
                <p>北京市朝阳区安定路39号长新大厦1001室</p>
                <p><a href="tel:400-852-9882">400-852-9882</a></p>
                <p><a href="tel:010-62353166">010-62353166</a></p>
                <p><a href="mailto:hz@infobigdata.com">hz@infobigdata.com</a></p>
              </div>
              <div class="dibuD2">
                <h3 class="h1">核心产品</h3>
                <div class="d1">
                  <ul class="u1">
                    <li ><a href="javascript:void(0)" ><span @click="tiao('rppghealth')">非接触远程健康检测系统</span></a></li>
                    <li ><a href="javascript:void(0)" ><span @click="tiao('cardiobrain')">心脑血管监测预警救援系统</span></a></li>
                    <li ><a href="javascript:void(0)" ><span @click="tiao('retirement')">吾征智慧康养系统</span></a></li>
                    <li ><a href="javascript:void(0)" ><span @click="tiao('ctimaging')">CT影像文本智能 解读系统</span></a></li>
                    <li ><a href="javascript:void(0)" ><span @click="tiao('healthycockpit')">吾征健康智能驾舱系统</span></a></li>
                    <li><a href="http://htcm.wuzhengai.com" target="_blank">AI辩证分型</a></li>
                    <li><a href="http://hlab.wuzhengai.com" target="_blank">化验单智能解读</a></li>
                    <li><a href="http://himage.wuzhengai.com" target="_blank">医学影像筛查</a></li>
                    <li><a href="http://henv.wuzhengai.com" target="_blank">室内病菌致病预警系统</a></li>
                    <li><a href="http://hdigit.wuzhengai.com" target="_blank">健康数字孪生人</a></li>
                    <li><a href="http://hdiet.wuzhengai.com" target="_blank">饮食AI行为预警</a></li>
                    <li><a href="http://hsign.wuzhengai.com" target="_blank">人体异常信号认知</a></li>
                    <li><a href="http://klg.wuzhengai.com" target="_blank">疾病知识图谱</a></li>
                    <li><a href="http://hapi.wuzhengai.com" target="_blank">吾征AI开放平台</a></li>
                    <li><a href="http://hgrs.wuzhengai.com" target="_blank">风险算法与模型</a></li>
                    <li><a href="http://rppg.wuzhengai.com" target="_blank">AI身心测评Pro</a></li>

                </ul>
                  </div>
              </div>
              <div class="dibuD3">
                <h3 class="h1">关注我们</h3>
                <div class="d1" style="margin-right:20px;">
                  <img class="img1" src="../assets/images/weixin_coder1.png" >
                  <div class="d2" style="text-align: center;">关注吾征AI公众号</div>
                </div>
                <div class="d1">
                  <img class="img1" src="../assets/images/app_coder1.png" >
                  <div class="d2" style="text-align: center;">下载吾征AI APP</div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="dibuX">
        <div class="dibuXd1">
           <p class="p1">
              © Copyright © 吾征智能技术（北京）有限公司 -
            <!--  &copy; Copyright © 2017-2021 中润普达 - -->
             <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备2021002262号-1</a>
            </p>
          </div>
      </div>
    </div>



  </div>
</template>

<script>
  export default {
  name: "",
  components: { },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
      tiao(url){

        this.$router.push(url);
        },
}
}

</script>

<style scoped>
.footer_D{
  background: #1C2733;
  box-sizing: border-box;
}
.dibu{

  padding-bottom: 70px;
  padding-top: 100px;
  font-size: 14px;
  font-family: '14px/1.7 pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif';
  color: #96a4b3;
}
.dibuD{
  width: 1140px;
  margin: auto;
}
.dibiF{
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    box-sizing: border-box;
}
.dibuD1{
  width: 40%;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
}
.dibuD1 .img1{
  display: block;
  width: 170px;
  height: 60px;
  margin-bottom: 25px;
}
.dibuD1 p{
  margin: 0;
  padding: 5px 0;
  text-align: left;
  font-size: 14px;
  font-family: '14px/1.7 pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif';
}
.dibuD1 a{
  line-height: 1.8;
  font-weight: 400;
  color: #96a4b3;
  font-size: 14px;
  font-family: '14px/1.7 pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif';
}
.dibuD2{
  width: 25%;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
}
.dibuD2 .h1{
    font-weight: 700;
    font-family: 'Poppins', sans-serif;
    color: #fff;
    font-size: 22px;
    margin-bottom: 25px;
}
.dibuD2 .d1{
    box-sizing: border-box;
}
.dibuD2 .u1{
    margin: 0;
    padding: 0;
    list-style: none;
}
.dibuD2 li{
  margin-bottom: 5px;
}
.dibuD2 p{
  font-size: 14px;
  font-family: '14px/1.7 pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif';
  margin-bottom: 5px;
  box-sizing: border-box;
}
.dibuD2 a{
  font-size: 14px;
  font-family: '14px/1.7 pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif';
  color: #96a4b3;
  line-height: 1.8;
}
.dibuD3{
  width: 35%;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
}
.dibuD3 .h1{
    font-weight: 700;
    font-family: 'Poppins', sans-serif;
    color: #fff;
    font-size: 22px;
    margin-bottom: 25px;
}
.dibuD3 .d1{
  display: inline-block;
  overflow: hidden;

}
.dibuD3 .d2{
    color: #96a4b3;
    margin: 0;
    padding: 5px 0;
    line-height: 1.8;
}
.dibuD3 .img1{
  width: 140px;
  height: 140px;
  display: block;
}
.dibuX{
  width: 1140px;
  margin: auto;
  padding: 15px;
}
.dibuXd1{
  text-align: center;
}
.dibuXd1 .p1{
  margin: 0;
  padding: 0;
  color: #96a4b3;
  line-height: 1.8;
  font-weight: 400;
  font-size: 14px;
  font-family: '14px/1.7 pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif';
}
.dibuXd1 a{
  color: #27AE60;
  font-size: 14px;
  font-family: '14px/1.7 pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif';
}



















/* -----=====底部样式=====----- */
/* .clear:after {
  display: block;
  content: "";
  clear: both;
  height: 0;
  visibility: hidden;
  font-size: 0;
  line-height: 0;
}
.clear {
  zoom: 1;
}
.z-footer-wrap {
  margin: 0 auto;
  background: #262728;
}
.z-footer {
  width: 1200px;
  margin: 0 auto;
}
.z-footer-us {
  padding: 40px 0;
  position: relative;
}
.z-footer-logo {
  float: left;
  width: 170px;
  height: 64px;
  background: url(../assets/img/footer_logo.png) no-repeat left center;
  padding: 43px 30px 43px 0;
  box-sizing: content-box;
  border-right: 1px solid #303132;
}
.z-footer-us dl {
  float: left;
  width: 300px;
  margin: 31px 30px;
}
.z-footer-us dt {
  float: left;
  width: 100%;
  font-size: 26px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-weight: bold;
}
.z-footer-us dd {
  float: left;
  width: 100%;
  height: 24px;
  line-height: 24px;
  color: #626364;
}
.z-footer-coder {
  float: right;
  margin-top: 5px;
}
.z-footer-wz {
  float: left;
  margin-left: 30px;
}
.z-footer-wz > div {
  width: 80px;
  height: 80px;
  padding: 10px;
  background: #fff;
  box-sizing: content-box;
  margin-left: 10px;
}
.z-footer-wz > div img {
  width: 80px;
}
.z-footer-wz em {
  display: block;
  text-align: center;
  width: 100%;
  line-height: 40px;
  color: #808182;
}
.z-footer-link {
  border-top: 1px solid #303132;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #808182;
}
.z-footer-link a {
  color: #808182;
  margin-right: 24px;
}
.z-footer-link a:hover {
  color: #14c86c;
} */
</style>



// WEBPACK FOOTER //
// src/components/footer.vue